import type { AdminRole } from '../../logic/interfaces'
import { useAppSelector } from '../../store/hooks'

export const SUPER_ADMIN_ROLE: AdminRole = 'superadmin'

/**
 * The single role signal the client gates on.
 *
 * `authSlice` seeds `user.role` from the localStorage `role` that login writes,
 * and `restoreSession` re-reads it after a hard reload, so it is already
 * populated on the first authenticated render — it is the same value the
 * sidebar's `requireRole` and the Add Admin role select key on.
 *
 * Every gate built on this is PRESENTATION ONLY. The writes behind them are
 * SuperAdmin-checked server-side; hiding the control only spares a plain Admin
 * a bare 400 toast on a button they were never allowed to press.
 */
const useIsSuperAdmin = (): boolean => useAppSelector((state) => state.auth.user.role) === SUPER_ADMIN_ROLE

export default useIsSuperAdmin
